





















































import { CallApi } from '@/api/call';
import { Forbidden } from '@/api/responses/forbidden';
import myActiveCallsTable from '@/components/calls/my-active-calls-table.vue';
import myCallbacksTable from '@/components/calls/my-callbacks-table.vue';
import nextAvailableCallTable from '@/components/calls/next-available-call-table.vue';
import loading from '@/components/loading.vue';
import layout from '@/layouts/app.vue';
import { Call } from '@/shared/call';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const callsModule = namespace('calls');
const callApi = new CallApi();

@Component({
    components: {
        layout,
        loading,
        myActiveCallsTable,
        myCallbacksTable,
        nextAvailableCallTable,
    },
})
export default class CallList extends Vue {
    @callsModule.Getter('nextAvailableCall') private nextAvailableCall!: Call | null;
    @callsModule.Getter('callbacks') private callbacks!: Array<Call>;
    @callsModule.Getter('activeCalls') private activeCalls!: Array<Call>;

    private isLoading: boolean = true;

    private async beginCallAsync(call: Call): Promise<void> {
        try {
            await callApi.beginCallAsync(call);
            this.$router.push({ name: 'view-client', params: { id: call.clientId! } });
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not begin call with ${call.firstName!.trim()} ${call.lastName!.trim()}.`, type: 'is-danger' });
            }
        }
    }

    private async mounted(): Promise<void> {
        this.isLoading = true;

        await Promise.all([
            this.$store.dispatch(`calls/loadMyCallsAsync`),
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`types/loadTypesAsync`),
        ]);

        this.isLoading = false;
    }
}
